import * as React from 'react';

export function renderNewLines(text: string) {
  return (<span dangerouslySetInnerHTML={{ __html: text.replace(/\n/, '<br>') }}/>);
}
